import { MEDIA_MOBILE } from "@utils/layout/breakpoints";

export function isMobileDevice(): boolean {
  if (typeof window === "undefined") return false;
  const userAgent = navigator.userAgent;
  const isMobileUA =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent,
    );
  const isMobileScreen =
    window.matchMedia?.(MEDIA_MOBILE).matches ?? false;
  const hasTouchScreen =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;
  return isMobileUA || (isMobileScreen && hasTouchScreen);
}

export function isPWA(): boolean {
  if (typeof window === "undefined") return false;
  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
  const isIOSStandalone =
    (window.navigator as Navigator & { standalone?: boolean }).standalone ===
    true;
  return isStandalone || isIOSStandalone;
}

export function isOnline(): boolean {
  if (typeof navigator === "undefined") return true;
  return navigator.onLine;
}
